import React from 'react';
import '../Groups.less';
import { CloseIcon, CallIcon, EditIcon, GroupsIcon } from '../../Common/Icons';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { Divider } from 'antd';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { truncateStringWith3Dots } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';

const ViewGroupScheduleCall = ({
  closeGroupModal,
  scheduleModalData,
  groupName,
  setEditScheduleData,
  onGroupModalActionClick,
  isStaffAdmin,
  userInfo,
  userTimezone,
  isStaff,
}) => {
  const trans = useSelector(translator);
  const userData = useSelector((user) => user.data.userInfo);
  const createdUserInfo = userData[scheduleModalData?.originalEvent?.useruuid];

  const formatDaysDisplay = (days) => {
    if (!days || days.length === 0) return trans('DOESNOTREPEAT');

    if (days.length === 7) {
      return trans('DAILY');
    }

    if (days.length === 1) {
      return days[0];
    }

    if (days.length === 2) {
      return `${days[0]} ${trans('AND_L')} ${days[1]}`;
    }

    const lastDay = days[days.length - 1];
    const otherDays = days.slice(0, -1).join(', ');
    return `${otherDays} ${trans('AND_L')} ${lastDay}`;
  };

  const formatReminderTime = (reminderSeconds) => {
    if (!reminderSeconds) return trans('NONE');

    const minutes = reminderSeconds / 60;
    if (minutes < 60) {
      return `${minutes} ${trans('MIN_L')}${minutes > 1 ? trans('S_L') : ''} ${trans('BEFORE')}`;
    }

    const hours = minutes / 60;
    if (hours < 24) {
      return `${hours} ${trans('HR_U')}${hours > 1 ? trans('S_L') : ''} ${trans('BEFORE')}`;
    }

    const days = hours / 24;
    return `${days} ${trans('DAY')}${days > 1 ? trans('S_L') : ''} ${trans('BEFORE')}`;
  };

  const onEditCallHandler = () => {
    closeGroupModal();
    onGroupModalActionClick(GroupModalActions.editScheduleCall);
    setEditScheduleData(scheduleModalData?.originalEvent);
  };

  return (
    <>
      <div className="modal-container">
        {/* Header Section */}
        <div className="group-modal-header-container">
          <div className="group-header-icon-title-new-container">
            <div className="group-modal-header-info">
              <div className="group-schedule-call-header-title">
                <div>
                  <CallIcon className="group-callactivity-icon-newui" />
                </div>
                <div className="group-header-title-new">
                  <span>{scheduleModalData?.title}</span>
                </div>
              </div>
              <div className="group-header-sub-title">
                <div className="group-schedule-information">
                  <div className="groups-schedule-typegroup">
                    <GroupsIcon className="groups-schedule-typegroup-icon" />
                    <span className="groups-schedule-typegroup-label">{trans('GROUP')}</span>
                  </div>
                  <span className="groups-schedule-selected-label">{groupName}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="group-modal-close-button">
            {isStaffAdmin ||
            (isStaff &&
              userInfo?.useruuid === scheduleModalData?.originalEvent?.event_originator_id) ? (
              <EditIcon style={{ width: '18' }} onClick={onEditCallHandler} />
            ) : null}
            <CloseIcon width="20" onClick={closeGroupModal} />
          </div>
        </div>

        <Divider className="groups-schedule-call-modal-divider" type="horizontal" />
        {/* Info Section */}
        <div className="groups-schedule-call-info-container">
          <div className="groups-schedule-call-info-title">{trans('GENERAL')}</div>
        </div>

        <div className="meeting-card-container">
          <div className="meeting-details-card">
            <div className="meeting-header">
              <div className="meeting-date">{scheduleModalData?.date}</div>
              <div className="meeting-time">{scheduleModalData?.time}</div>
            </div>

            <div className="meeting-info">
              <div className="info-row">
                <span className="info-label">{trans('REPEATS:')}</span>
                <span className="info-value">{formatDaysDisplay(scheduleModalData?.days)}</span>
              </div>

              <div className="info-row">
                <span className="info-label">{trans('ALERT:')}</span>
                <span className="info-value">
                  {formatReminderTime(scheduleModalData?.originalEvent?.reminder)}
                </span>
              </div>
            </div>

            <div className="meeting-creator">
              {trans('CREATEDON')} {scheduleModalData?.date} {trans('BY_L')}{' '}
              {createdUserInfo?.firstname}
            </div>
          </div>

          <div className="meeting-description-section">
            <h3 className="description-title">{trans('DESCRIPTION')}</h3>
            <div className="description-card">
              <p className="description-text">{scheduleModalData?.description}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewGroupScheduleCall;
